export const shouldDisplayMixVariation = (
	track: Pick<Track, 'mix' | 'mixVariation'>
): boolean => track.mix > 1 && !!track.mixVariation?.length
